import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "hooks/useStore";

const LogOut = () => {
    const { logout } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        // Clear all authentication data
        logout();
        
        // Redirect to login page
        navigate("/login");
    }, [logout, navigate]);

    return (
        <div className="flex items-center justify-center min-h-screen">
            <div className="text-center">
                <h2 className="text-2xl font-semibold mb-4">Logging out...</h2>
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-custom-500 mx-auto"></div>
            </div>
        </div>
    );
};

export default LogOut;
